import axios from '@/config/api.request'

export default {
    // 查询全部类别
    getCategories() {
        return axios.request({
            url: '/set/category/categories',
            method: 'get'
        })
    }
}